<!--
 * @Author: znn
 * @Date: 2021-04-20 11:57:04
 * @LastEditTime: 2021-04-21 14:12:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\orderShipInfo.vue
-->
<template>
  <div class="ship_infos">
    <!--商品  暂时无接口-->
    <div class="order_goods">
      <h2>订单商品</h2>
      <div class="goods">
        <img
          :src="goodsExpressInfo.goods_image?goodsExpressInfo.goods_image:imgPath+'yj_defatult.png'"
          alt
        />
        <div class="rightgoods">
          <p>{{goodsExpressInfo.goods_name}}</p>
          <b>规格：{{goodsExpressInfo.sku_name}}</b>
          <span>
            <i>￥</i>
            {{goodsExpressInfo.goods_price_dollar}}
          </span>
          <b>x{{goodsExpressInfo.num}}</b>
        </div>
      </div>
    </div>
    <!--    物流公司-->
    <div class="wl_danwei mt20">
      <p>快递公司：{{goodsExpressInfo.express_name}}</p>
      <p class="mt20">快递单号：{{goodsExpressInfo.express_no}}</p>
    </div>

    <!--    物流跟踪-->

    <div class="wl_step mt20" v-if="expressInfo.length > 0">
      <van-steps direction="vertical" :active="0">
        <van-step v-for="item in expressInfo">
          <h3>{{item.accept_station}}</h3>
          <p>{{item.accept_time}}</p>
        </van-step>
        <!-- <van-step>
          <h3>城市物流状态2</h3>
          <p>2016-07-11 10:00</p>
        </van-step>
        <van-step>
          <h3>快件已发货</h3>
          <p>2016-07-10 09:30</p>
        </van-step>-->
      </van-steps>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Step, Steps } from 'vant'
Vue.use(Step)
Vue.use(Steps)
export default {
  name: 'orderShipInfo',
  data() {
    return {
      order_id: '', //订单id
      goodsExpressInfo: {}, //物流信息
      expressInfo: [], //物流详细
    }
  },
  created() {
    ;(this.order_id = this.$route.query.order_id),
      (this.order_goods_id = this.$route.query.order_goods_id),
      (this.express_no = this.$route.query.express_no)
  },
  mounted() {
    this.prohibitweixinShare()
    this.getOrderExpressInfo()
  },
  methods: {
    //获取物流跟踪详情
    getOrderExpressInfo() {
      this.http('ClientOrder.getGoodsExpressInfo', {
        order_goods_id: this.order_goods_id,
        express_no: this.express_no,
      }).then((res) => {
        if (res.status == 200) {
          console.log(res)
          ;(this.goodsExpressInfo = res.content),
            (this.expressInfo = res.content.qst_goods_express_list)
        } else {
          Toast(res.msg)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.ship_infos {
  background: #f8f8f8;
  min-height: 100vh;
  .order_goods {
    width: 710px;
    background: #ffffff;
    border-radius: 14px;
    margin: 0 auto;
    overflow: hidden;
    h2 {
      color: #333;
      font-size: 30px;
      line-height: 100px;
      padding: 0 40px;
    }
    .goods {
      margin: 0 40px;
      width: 630px;
      border-top: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      img {
        width: 140px;
        height: 140px;
        border-radius: 10px;
        margin: 24px 24px 24px 0;
        border: 1px solid #eee;
      }
      .rightgoods {
        width: 470px;
        margin-top: 24px;
        p {
          width: 470px;
          font-size: 26px;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: box;
          display: -webkit-box;
          line-clamp: 2;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          margin-bottom: 10px;
        }
        b {
          color: #999;
          font-size: 24px;
        }
        span {
          color: #ff8737;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 500;
          padding: 0 20px 0 50px;
          i {
            font-size: 24px;
            font-family: normal !important;
          }
        }
      }
    }
  }
  .wl_danwei {
    width: 630px;
    background: #fff;
    border-radius: 14px;
    padding: 40px;
    margin: 0 auto;
    p {
      font-size: 26px;
      color: #333;
    }
  }
  .wl_step {
    width: 630px;
    background: #fff;
    border-radius: 14px;
    padding: 40px;
    margin: 0 auto;
  }
}
</style>
